import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=67e909c0&scoped=true&lang=pug&"
import script from "./MobileApp.vue?vue&type=script&lang=js&"
export * from "./MobileApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e909c0",
  null
  
)

export default component.exports